const STORAGE_KEYS = {
	USER_ID: 'notify-x-user-id',
	USERNAME: 'notify-x-username',
	FCM_TOKEN: 'notify-x-fcm-token',
} as const;

export class StorageService {
	public getUserId(): number | null {
		const userId = localStorage.getItem(STORAGE_KEYS.USER_ID);
		return userId ? Number.parseInt(userId, 10) : null;
	}

	public setUserId(userId: number): void {
		localStorage.setItem(STORAGE_KEYS.USER_ID, userId.toString());
	}

	public getUsername(): string | null {
		return localStorage.getItem(STORAGE_KEYS.USERNAME);
	}

	public setUsername(username: string): void {
		localStorage.setItem(STORAGE_KEYS.USERNAME, username);
	}

	public getFcmToken(): string | null {
		return localStorage.getItem(STORAGE_KEYS.FCM_TOKEN);
	}

	public setFcmToken(token: string): void {
		localStorage.setItem(STORAGE_KEYS.FCM_TOKEN, token);
	}

	public clear(): void {
		localStorage.removeItem(STORAGE_KEYS.USER_ID);
		localStorage.removeItem(STORAGE_KEYS.USERNAME);
		localStorage.removeItem(STORAGE_KEYS.FCM_TOKEN);
	}
}
